export default {
    transferOperationType: 'نوع انتقال',
    transferOperationTypeTitle: 'عنوان',
    transferOperationTypeStatus: 'وضعیت',
    transferOperationTypes: 'انواع انتقال',
    editTransferOperationType: 'ویرایش نوع انتقال',
    addTransferOperationType: 'نوع انتقال جدید',
}